import { Helmet } from "react-helmet-async";
import type { JsonLdValue } from "@/src/common/types/json-ld";

interface JsonLdProps {
	data: JsonLdValue;
}

export function JsonLd({ data }: JsonLdProps) {
	return (
		<Helmet>
			<script type="application/ld+json">{JSON.stringify(data)}</script>
		</Helmet>
	);
}
